// extracted by mini-css-extract-plugin
var _1 = "styles-module__freeLink___gSWVi";
var _2 = "styles-module__freeSubtext___fv0Zo";
var _3 = "styles-module__header___aA1ek";
var _4 = "styles-module__subtext___EmxXZ";
var _5 = "styles-module__surveyText___BCr62";
var _6 = "styles-module__title___GC_ua";
export { _1 as "freeLink", _2 as "freeSubtext", _3 as "header", _4 as "subtext", _5 as "surveyText", _6 as "title" }
